const shopify_klevu_token = "7c27658335d524cae40d0b26b357d075";
const primary_market = "UK";
const klevuBaseUrl = "https://cultpens.com/"

klevu.interactive(function () {
  // HELPER FUNCTIONS
  function extractSlug(url) {
    const path = new URL(url).pathname;
    const parts = path.split('/');
    return parts[parts.length - 1];
  }
  function generateQueryString(id, handles) {
    let productQueries = '';

    for (let i = 0; i < id.length; i++) {
      productQueries += `
            product_${id[i]}: productByHandle(handle: "${handles[i]}") {
                id
                handle
                priceRange {
                ...MinMaxVariantPrice
                }
                compareAtPriceRange {
                ...MinMaxVariantPrice
                }
            }`;
    }
    return productQueries;
  }
  function formatPrice(price, currency, locale = navigator.language) {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(price);
  }
  function findProductList(data) {
    return data.find(item => item.id === 'productList');
  }
  function wipeElements(elements) {
    elements.forEach((element) => {
      if (typeof element === 'string') {
        element = document.getElementById(element);
      }

      if (element) {
        element.innerHTML = '';
      }
    });
  }
  function sendRequest(queryString, country, callback) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("X-Shopify-Storefront-Access-Token", shopify_klevu_token);

    var graphqlPayload = JSON.stringify({
      query: `query getLocalizedVariant(
                $country: CountryCode
            ) @inContext(country: $country) {

                ${queryString}
                
            }
            fragment Price on MoneyV2 {
                amount
                currencyCode
            }
            fragment MinMaxVariantPrice on ProductPriceRange {
                maxVariantPrice {
                ...Price
                }
                minVariantPrice {
                ...Price
                }
            }`,
      variables: { "country": country }
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: graphqlPayload,
      redirect: 'follow'
    };

    fetch(klevuBaseUrl + "/api/2023-01/graphql.json", requestOptions)
      .then(response => response.text())
      .then(callback)
      .catch(error => console.log('error', error));
  }
  function renderPricesOnFrontend(result, productList, priceSelector, listItemSelector, country, currency) {

    const priceBeforeDiscountSelector = priceSelector.replace('Sale', 'Orig');
    const helpers = klevu.search.base.getScope().template.getHelpers();
    const resultObject = JSON.parse(result);

    // Loop through all the items from the current Klevu response
    for (const currentProduct of productList) {
      const { id: product_id } = currentProduct;

      // return if the product is excluded from the store and there's no data for it
      if (resultObject.data[`product_${product_id}`] === null) continue;
      const compareAtMaxVariantPrice = resultObject.data[`product_${product_id}`].compareAtPriceRange.maxVariantPrice.amount;
      const { minVariantPrice, maxVariantPrice } = resultObject.data[`product_${product_id}`].priceRange;
      const { amount: minAmount } = minVariantPrice;
      const { amount: maxAmount } = maxVariantPrice;
      const label = maxAmount !== minAmount ? 'From' : '';

      // Now, we are selecting the proper elements by ID and grab prices from our POST request
      const listItem = document.querySelectorAll(`${listItemSelector}[data-id="${product_id}"]`); // our parent element, referring by ID

      [...listItem].forEach((list) => {
        const salePriceItem = list.querySelector(priceSelector);
        const origPriceItem = list.querySelector(priceBeforeDiscountSelector);
        domChangePrice(salePriceItem, origPriceItem);
      });

      function domChangePrice(salePriceItem, origPriceItem) {
        const price = helpers.formatPrice(minAmount, currency, country);
        const priceBeforeDiscount = helpers.formatPrice(compareAtMaxVariantPrice, currency, country);
        if (salePriceItem) {
          salePriceItem.innerHTML = `<span data-globalE-price="${price}" class="klevu-globalE-prices">${label} ${price}</span>`;
        }
        if (origPriceItem && parseFloat(compareAtMaxVariantPrice) > parseFloat(minAmount)) {
          origPriceItem.innerHTML = `<span data-globalE-price="${priceBeforeDiscount}" class="klevu-globalE-prices">${priceBeforeDiscount}</span>`;
        }
      };
    }
  }
  function prependShopifyRoute(url, value) {
    // Browser-compatible check for Shopify.routes.root
    const shopifyRoute = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '';

    // The klevuBaseUrl potentialy has a trailing slash
    // Check if klevuBaseUrl exists, is not null, is not an empty string, and has a length greater than 5
    // Use the replace() method and a regular expression to remove the trailing slash, if present
    const isValidBaseUrl = typeof klevuBaseUrl !== 'undefined' && klevuBaseUrl !== null && klevuBaseUrl !== '' && klevuBaseUrl.length > 10;
    const baseUrl = isValidBaseUrl ? klevuBaseUrl.replace(/\/$/, '') : extractOrigin(value.records[0].url);

    if (url.startsWith(baseUrl)) {
      let newUrl = url.replace(baseUrl, baseUrl + shopifyRoute);
      // Remove any double slashes after the shopifyRoute
      newUrl = newUrl.replace(shopifyRoute + '/', shopifyRoute);
      return newUrl;
    }

    return url;
  }
  function extractOrigin(url) {
    // Extract the origin from the given URL
    const urlObj = new URL(url);
    return urlObj.origin;
  }
  function isShopifyRouteValid(data, shopifyRoute) {
    // Browser-compatible check for Shopify.routes.root
    shopifyRoute = shopifyRoute || (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '';
    // Check if the request was successful and if shopifyRoute is different from '/' and has a length of at least 2
    return data.context.isSuccess && shopifyRoute !== '/' && shopifyRoute.length >= 2;
  }

  // set helper functions as the global Klevu helpers
  klevu.search.base.getScope().template.setHelper('extractSlug', extractSlug);
  klevu.search.base.getScope().template.setHelper('generateQueryString', generateQueryString);
  klevu.search.base.getScope().template.setHelper('formatPrice', formatPrice);
  klevu.search.base.getScope().template.setHelper('findProductList', findProductList);
  klevu.search.base.getScope().template.setHelper('wipeElements', wipeElements);
  klevu.search.base.getScope().template.setHelper('sendRequest', sendRequest);
  klevu.search.base.getScope().template.setHelper('renderPricesOnFrontend', renderPricesOnFrontend);
  klevu.search.base.getScope().template.setHelper('prependShopifyRoute', prependShopifyRoute);
  klevu.search.base.getScope().template.setHelper('isShopifyRouteValid', isShopifyRouteValid);
  // HELPER FUNCTIONS END
});
// review position code
klevu.beforeActivation('all', function (data, scope) {
    scope.kScope.template.setTemplate(klevuLandingTemplateProductBlockCustom, "productBlock", true);
})

const klevuLandingTemplateProductBlockCustom = `<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <div class="kuProdWrap">
        <header ku-block data-block-id="ku_landing_result_item_header">
            <%=helper.render('landingProductBadge', scope, data, dataLocal) %>
        </header>
        <% var desc = [dataLocal.summaryAttribute,dataLocal.packageText,dataLocal.summaryDescription].filter(function(el) { return el; }); desc = desc.join(" "); %>
        <main ku-block data-block-id="ku_landing_result_item_info">
            <div class="kuProdTop">
                <div class="klevuImgWrap">
                    <a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView">
                        <img src="<%=dataLocal.image%>" origin="<%=dataLocal.image%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
                        <%=helper.render('landingImageRollover', scope, data, dataLocal) %>
                    </a>                        
                </div>
                <!-- <div class="kuQuickView">
                    <button data-id="<%=dataLocal.id%>" class="kuBtn kuBtnLight kuQuickViewBtn" role="button" tabindex="0" area-label="">Quick view</button>
                </div> -->
            </div>
        </main>
        <footer ku-block="" data-block-id="ku_landing_result_item_footer">
            <div class="kuProdBottom">               
                <div class="kuName kuClippedOne"><a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView" title="<%= updatedProductName %>"><%= updatedProductName %></a></div>
                <div class='reviewWrapper'>
                  <%=helper.render('klevuLandingProductRating',scope,data,dataLocal) %>
                </div>
                <div class='outOfSt'>
                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('landingProductStock', scope, data, dataLocal) %>              
                <% } %>
                </div>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="kuPrice">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>
                            <div class="kuSalePrice kuStartPrice kuClippedOne">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%>
                                </span> <%=dataLocal.currency%><%=kuStartPrice%>
                            </div>
                        <% } else if(kuSalePrice < kuPrice) { %>
                            <div class="kuOrigPrice kuClippedOne"><%=dataLocal.currency%><%=kuPrice%></div>
                            <div class="kuSalePrice kuClippedOne"><%=dataLocal.currency%><%=kuSalePrice%></div>
                        <% } else { %>
                            <div class="kuSalePrice kuClippedOne"><%=dataLocal.currency%><%=kuSalePrice%></div>
                        <% } %>
                    </div>
                <% } %>
                <%=helper.render('klevuLandingProductAddToCart',scope,data,dataLocal) %>
            </div>
        </footer>
    </div>
</li>
`;
// Quick
klevu.coreEvent.build({
  name: "setShopifyGlobalEQuickOverride",
  fire: function () {
    if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigQuick.build", false)) {
      return true;
    }
    return false;
  },
  maxCount: 150,
  delay: 100
});

klevu.coreEvent.attach("setShopifyGlobalEQuickOverride", {
  name: "attachToShopifyGlobalEQuickOverride",
  fire: function () {

    klevu.each(klevu.search.extraSearchBox, function (key, box) {

      // set helpers to use them in every scope: quick search, landing and category pages
      const helpers = klevu.search.base.getScope().template.getHelpers();

      box.getScope().chains.template.events.add({
        name: "globalEPriceChange",
        fire: function (data, scope) {
          try {
            if (typeof Shopify.country !== 'undefined' && typeof primary_market !== 'undefined' && Shopify.country.toLowerCase() !== primary_market.toLowerCase()) {

              // hide the prices with the wrong currency:
              helpers.wipeElements(document.querySelectorAll('.klevuQuickSalePrice'));
              helpers.wipeElements(document.querySelectorAll('.klevuQuickOrigPrice'));

              // 1. Let's gather all the IDs of the products we're seeing to the Array "arrayIDs":
              const klevuResponse = klevu.getObjectPath(data, "response.current.queryResults");
              const productList = typeof helpers.findProductList(klevuResponse) !== 'undefined' ? (helpers.findProductList(klevuResponse)).records : null;

              if (!productList) return; // return if there's no data in the response. Useful for initail popup in Quick Search

              const arrayIDs = productList.map(element => element.id);
              const urlKeys = productList.map(element => helpers.extractSlug(element.url));
              const generatedQueryStringForGraphQLrequest = helpers.generateQueryString(arrayIDs, urlKeys);

              // 2. Make a request. The GraphQL request code & data is below. Show our data on the Frontend:
              helpers.sendRequest(generatedQueryStringForGraphQLrequest, Shopify.country, (result) => {
                helpers.renderPricesOnFrontend(result, productList, '.klevuQuickSalePrice', '.kuQuickResultsListContainer .klevuProduct', Shopify.country, Shopify.currency.active);

              });
            }
          } catch (error) {
            console.log(error);
          }
        }
      });

      // Fix: Rewrite ALL links in the quick search dropdown to include the Shopify route prefix.
      // This covers: Suggestions links, View All link, banner links, and any product/category
      // links that may have been missed by the render-chain rewrite.
      // Placed in the EVENTS chain (not render chain) because the events chain fires AFTER
      // the DOM has been fully rendered, avoiding the race condition where the render chain
      // fires before Klevu's async template engine has finished building the DOM.
      box.getScope().chains.template.events.add({
        name: "rewriteDropdownLinks",
        fire: function (data, scope) {
          var shopifyRoute = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root)
            ? Shopify.routes.root
            : '/';

          if (shopifyRoute === '/' || shopifyRoute.length < 2) return;

          var routePrefix = shopifyRoute.replace(/\/$/, '');

          // Target ALL links inside the quick search dropdown area.
          // .klevuQuickSearchingArea contains: Suggestions, View All, Category/Collection,
          //   Content/Blog, and the promotional banner.
          // .kuQuickResultsListContainer contains: Product links.
          var links = document.querySelectorAll(
            '.klevuQuickSearchingArea a[href], .kuQuickResultsListContainer a[href]'
          );

          links.forEach(function (link) {
            var href = link.getAttribute('href');
            if (!href) return;

            // Skip links that already contain the route prefix
            if (href.indexOf(routePrefix + '/') !== -1) return;

            // Skip external links (different domain)
            try {
              var urlObj = new URL(href, window.location.origin);
              if (urlObj.origin !== window.location.origin) return;
              link.setAttribute('href', urlObj.origin + routePrefix + urlObj.pathname + urlObj.search + urlObj.hash);
            } catch (e) {
              // For simple relative URLs, prepend the route prefix
              if (href.charAt(0) === '/') {
                link.setAttribute('href', routePrefix + href);
              }
            }
          });
        }
      });

      box.getScope().chains.template.events.add({
        name: "preventNewTabKlevu",
        fire: function(data, scope) {
            setTimeout(() => {

                document.addEventListener('click', function(e) {

                    const el = e.target.closest('.klevuPopularSearch a, .kuPopularSearchTerms a,.kuRecentSearchTerms a, .klevu-trending a');

                    if (!el) return;

                    // detect if Klevu is trying to open new tab
                    if (e.ctrlKey || e.metaKey || el.target === "_blank") {
                        e.preventDefault();
                    }

                    // FORCE same tab navigation
                    if (el.href) {
                        e.preventDefault();
                        window.location.assign(el.href);
                    }

                }, true); // capture phase (important)

            }, 0);
        }
      });

      // change the Form action according to the Shopify.routes.root
        box.getScope().chains.template.process.success.add({
        name: "changeFormAction",
        fire: function (data, scope) {
          // Retrieve the Shopify.routes.root value if available
          const shopifyRoute = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '';

          // Get the current form and its action
          const currentForm = scope.closest('form');
          const currentFormAction = currentForm.action;
          const klevuLandingUrl = klevu.settings.url.landing.startsWith('/') ? klevu.settings.url.landing.replace(/^\/+/g, "") : klevu.settings.url.landing;
          // Check if shopifyRoute is not empty
          if (shopifyRoute) {
            // Check if cleanedShopifyRoute is not already present in the currentFormAction
            if (!currentFormAction.startsWith(shopifyRoute)) {
              const domain = /^(https?:\/\/[^\/]+)\//.exec(currentFormAction);
              if (domain && domain[1]) {
                currentForm.action = domain[1] + shopifyRoute + klevuLandingUrl
              }

            }
          }
        }
      });

      // Fix: Rewrite Klevu's KMC keyword redirect URLs to include the Shopify route prefix.
      // When a user presses Enter in the search box, Klevu's core "checkRedirect" chain
      // checks settings.search.redirects for a matching keyword and navigates to the URL
      // via document.location. The KMC-configured URLs are absolute (e.g.
      // https://cultpens.com/collections/kaweco) but do NOT include the locale prefix
      // (e.g. /en-us). This chain runs after "addRedirectURLs" (which populates the
      // redirects from the KMC keyword-URL map) and rewrites every redirect URL to
      // insert the Shopify route prefix after the domain, so the user lands on the
      // correct localised page.
      box.getScope().chains.template.process.success.addAfter("addRedirectURLs", {
        name: "rewriteRedirectURLs",
        fire: function (data, scope) {
          var shopifyRoute = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root)
            ? Shopify.routes.root
            : '/';

          // Only rewrite when a non-default locale prefix is active
          if (shopifyRoute === '/' || shopifyRoute.length < 2) return;

          var routePrefix = shopifyRoute.replace(/\/$/, ''); // e.g. "/en-us"

          var redirects = klevu.getSetting(scope.kScope.settings, "settings.search.redirects");
          if (!redirects || klevu.isUndefined(redirects)) return;

          for (var keyword in redirects) {
            if (!redirects.hasOwnProperty(keyword)) continue;
            var url = redirects[keyword];
            if (!url) continue;

            // Skip URLs that already contain the route prefix
            if (url.indexOf(routePrefix + '/') !== -1) continue;

            try {
              var urlObj = new URL(url, window.location.origin);
              // Only rewrite URLs on the same domain
              if (urlObj.origin === window.location.origin) {
                redirects[keyword] = urlObj.origin + routePrefix + urlObj.pathname + urlObj.search + urlObj.hash;
              }
            } catch (e) {
              // For relative URLs, simply prepend the route prefix
              if (url.charAt(0) === '/') {
                redirects[keyword] = routePrefix + url;
              }
            }
          }

          klevu.setSetting(scope.kScope.settings, "settings.search.redirects", redirects);
        }
      });

    });

    klevu({
      powerUp: {
        quick: true
      }
    });
  }
});

// QUICK SEARCH DROPDOWN URL FIX: Safety-net for all links in the instant search dropdown.
// Uses a three-layer approach for reliability, similar to the RECS URL fix:
// Layer 1: Click delegation (capture phase) — intercepts clicks on any link that still
//          lacks the locale prefix, even if the events-chain rewrite missed it.
// Layer 2: MutationObserver — rewrites href attributes in the DOM as soon as Klevu
//          renders new content, covering middle-click, right-click "copy link", etc.
// Layer 3: Polling fallback — catches any edge case the observer missed.
(function () {
  var shopifyRoute = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root)
    ? Shopify.routes.root
    : '/';

  if (shopifyRoute === '/' || shopifyRoute.length < 2) return;

  var routePrefix = shopifyRoute.replace(/\/$/, '');

  // Shared rewrite function for any container
  function rewriteDropdownURLs(container) {
    var links = container.querySelectorAll('a[href]');
    links.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      // Skip links that already have the route prefix
      if (href.indexOf(routePrefix + '/') !== -1) return;
      // Only rewrite same-origin links
      try {
        var urlObj = new URL(href, window.location.origin);
        if (urlObj.origin === window.location.origin) {
          link.setAttribute('href', urlObj.origin + routePrefix + urlObj.pathname + urlObj.search + urlObj.hash);
        }
      } catch (ex) {}
    });
  }

  // --- LAYER 1: Click delegation (capture phase) ---
  // Covers: .klevuQuickSearchingArea (suggestions, categories, banners, View All)
  //         .kuQuickResultsListContainer (product links)
  document.addEventListener('click', function (e) {
    var link = e.target.closest(
      '.klevuQuickSearchingArea a[href], .kuQuickResultsListContainer a[href]'
    );
    if (!link) return;

    var href = link.getAttribute('href');
    if (href && href.indexOf(routePrefix + '/') === -1) {
      try {
        var urlObj = new URL(href, window.location.origin);
        if (urlObj.origin === window.location.origin) {
          e.preventDefault();
          window.location.href = urlObj.origin + routePrefix + urlObj.pathname + urlObj.search + urlObj.hash;
        }
      } catch (ex) {
        if (href.charAt(0) === '/') {
          e.preventDefault();
          window.location.href = routePrefix + href;
        }
      }
    }
  }, true);

  // --- LAYER 2: MutationObserver on the quick search containers ---
  var observedContainers = new WeakSet();

  function observeQuickSearchContainers() {
    // The main quick search dropdown containers
    var selectors = ['.klevuQuickSearchingArea', '.kuQuickResultsListContainer', '.klevuQuickSearchResults'];
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        // Rewrite links in the closest quick search container
        var container = mutation.target.closest(
          '.klevuQuickSearchingArea, .kuQuickResultsListContainer, .klevuQuickSearchResults'
        );
        if (container) {
          rewriteDropdownURLs(container);
        }
      });
    });

    selectors.forEach(function (sel) {
      var containers = document.querySelectorAll(sel);
      containers.forEach(function (container) {
        if (!observedContainers.has(container)) {
          observer.observe(container, { childList: true, subtree: true });
          observedContainers.add(container);
        }
      });
    });
  }

  // Initial observation attempt
  observeQuickSearchContainers();

  // Also watch body for the quick search containers being added later (they may not
  // exist in the DOM until the user focuses the search box for the first time)
  var bodyObserver = new MutationObserver(function (mutations) {
    var shouldRecheck = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Check if this node IS or CONTAINS a quick search container
          if (node.classList &&
            (node.classList.contains('klevuQuickSearchingArea') ||
             node.classList.contains('kuQuickResultsListContainer') ||
             node.classList.contains('klevuQuickSearchResults'))) {
            rewriteDropdownURLs(node);
            shouldRecheck = true;
          }
          if (node.querySelectorAll) {
            var inner = node.querySelectorAll(
              '.klevuQuickSearchingArea, .kuQuickResultsListContainer, .klevuQuickSearchResults'
            );
            inner.forEach(function (c) {
              rewriteDropdownURLs(c);
              shouldRecheck = true;
            });
          }
        }
      });
    });
    if (shouldRecheck) {
      observeQuickSearchContainers();
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  // --- LAYER 3: Polling fallback (5 seconds after each search keystroke) ---
  // Instead of a fixed 10-second poll, we hook into the search input to trigger
  // targeted rewrites shortly after each keystroke settles.
  var pollTimer = null;
  var searchInputs = document.querySelectorAll('input[name=q], .kuSearchInput, #header-search');
  searchInputs.forEach(function (input) {
    input.addEventListener('input', function () {
      if (pollTimer) clearTimeout(pollTimer);
      // Run 3 rewrite passes at 200ms, 500ms, and 1000ms after typing stops
      var delays = [200, 500, 1000];
      delays.forEach(function (delay) {
        setTimeout(function () {
          var containers = document.querySelectorAll(
            '.klevuQuickSearchingArea, .kuQuickResultsListContainer'
          );
          containers.forEach(function (c) { rewriteDropdownURLs(c); });
        }, delay);
      });
    });
  });
})();
// QUICK SEARCH DROPDOWN URL FIX END

// Landing and Catnav
klevu.coreEvent.build({
  name: "setShopifyGlobalELandingOverride",
  fire: function () {
    if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build") || klevu.getSetting(klevu, "settings.flags.setRemoteConfigCatnav.build")) {
      if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build")) {
        window.pageType = 'landing';
        window.setRemoteConfig = 'setRemoteConfigLanding';
      }
      if (klevu.getSetting(klevu, "settings.flags.setRemoteConfigCatnav.build")) {
        window.pageType = 'catnav';
        window.setRemoteConfig = 'setRemoteConfigCatnav';
      }
      return true;
    }
    return false;
  },
  maxCount: 150,
  delay: 100
});

klevu.coreEvent.attach("setShopifyGlobalELandingOverride", {
  name: "attachToShopifyGlobalELandingOverride",
  fire: function () {
    document.getElementsByTagName('body')[0].classList.add('klevu-page');

    // set helpers to use them in every scope: quick search, landing and category pages
    const helpers = klevu.search.base.getScope().template.getHelpers();

    klevu.search[window.pageType].getScope().chains.template.events.add({
      name: "globalEPriceChange",
      fire: function (data, scope) {

        try {
          if (typeof Shopify.country !== 'undefined' && typeof primary_market !== 'undefined' && Shopify.country.toLowerCase() !== primary_market.toLowerCase()) {

            // hide the prices with the wrong currency:
            helpers.wipeElements([...document.querySelectorAll('.kuSalePrice')]);
            helpers.wipeElements([...document.querySelectorAll('.kuOrigPrice')]);

            // 1. Let's gather all the IDs of the products we're seeing to the Array "arrayIDs":
            const klevuResponse = klevu.getObjectPath(data, "response.current.queryResults");
            const productList = typeof helpers.findProductList(klevuResponse) !== 'undefined' ? (helpers.findProductList(klevuResponse)).records : null;

            if (!productList) return; // return if there's no data in the response. Useful for initail popup in Quick Search

            const arrayIDs = productList.map(element => element.id);
            const urlKeys = productList.map(element => helpers.extractSlug(element.url));
            const generatedQueryStringForGraphQLrequest = helpers.generateQueryString(arrayIDs, urlKeys);

            // 2. Make a request. The GraphQL request code & data is below. Show our data on the Frontend:
            helpers.sendRequest(generatedQueryStringForGraphQLrequest, Shopify.country, (result) => {
              helpers.renderPricesOnFrontend(result, productList, '.kuSalePrice', '.klevuProduct', Shopify.country, Shopify.currency.active);
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    });

    klevu.search[window.pageType].getScope().chains.template.render.addBefore("renderResponse", {
      name: "respectRootInProductURLs",
      fire: function (data, scope) {
        if (helpers.isShopifyRouteValid(data)) {
          // Iterate through each query result in the response
          klevu.each(data.response.current.queryResults, function (key, value) {
            // Update each record's URL with the Shopify route
            value.records.forEach(record => {
              record.url = helpers.prependShopifyRoute(record.url, value);
            });
          });
        }
      }
    });

    if (window.pageType === 'landing') { klevu({ powerUp: { landing: true } }) }
    if (window.pageType === 'catnav') { klevu({ powerUp: { catnav: true } }) }

  }
});


// RECS
var RECS_BASE = klevu.recs.base;
RECS_BASE.getScope().chains.search.control.add({
  name: "bindSearchResultElementEventsCustom",
  fire: function (data, scope) {
    var RECS_BOX = scope.recsScope.searchObject;
    RECS_BOX.getScope().chains.template.events.add({
      name: "attachObserverFunctionForItemClick_custom",
      fire: function (data, scope) {
        try {
          const helpers = klevu.search.base.getScope().template.getHelpers();

          if (typeof Shopify.country !== 'undefined' && typeof primary_market !== 'undefined' && Shopify.country.toLowerCase() !== primary_market.toLowerCase()) {
            // hide the prices with the wrong currency:
            helpers.wipeElements([...document.querySelectorAll('.klevu-recs.klevuTarget .kuSalePrice')]);
            helpers.wipeElements([...document.querySelectorAll('.klevu-recs.klevuTarget .kuOrigPrice')]);

            // 1. Let's gather all the IDs of the products we're seeing to the Array "arrayIDs":
            const klevuResponse = klevu.getObjectPath(data, "response.current.queryResults");
            const productList = klevuResponse[0].records;
            if (!productList) return; // return if there's no data in the response. Useful for initial popup in Quick Search

            const arrayIDs = productList.map(element => element.id);
            const urlKeys = productList.map(element => helpers.extractSlug(element.url));
            const generatedQueryStringForGraphQLrequest = helpers.generateQueryString(arrayIDs, urlKeys);

            // 2. Make a request. The GraphQL request code & data is below. Show our data on the Frontend:
            helpers.sendRequest(generatedQueryStringForGraphQLrequest, Shopify.country, (result) => {
              /** The classes for klevu RECS GUI editor and Code editor are different.
               *  kcResultItem and kcSalePrice - are classes RECS GUI editor
               *  kuRECS-itemWrap and kuSalePrice - are classes RECS Code editor
               */

              // GUI editor:
              if (document.querySelectorAll('.kcResultItem')?.length > 0) {
                helpers.renderPricesOnFrontend(result, productList, ".kcSalePrice, .kcResultItemPriceValue.kcStartPrice", ".kcResultItem", Shopify.country, Shopify.currency.active);
              }
              // Code editor:
              else {
                helpers.renderPricesOnFrontend(result, productList, ".kuSalePrice", ".kuRECS-itemWrap", Shopify.country, Shopify.currency.active);
              }
            });
          }
        } catch (error) {
          console.log(error);
        }

      }
    });

  }
});
// RECS END

// RECS URL FIX: Rewrite Klevu recs carousel URLs to include the Shopify route prefix (e.g. /en-us)
// Uses a three-layer approach for reliability:
// Layer 1: Click delegation (safety net - intercepts clicks even if href was never rewritten)
// Layer 2: MutationObserver (rewrites href in DOM for middle-click, right-click, copy link)
// Layer 3: Polling fallback (catches any edge case the observer missed)
(function () {
  var shopifyRoute = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root)
    ? Shopify.routes.root
    : '/';

  if (shopifyRoute === '/' || shopifyRoute.length < 2) return;

  var routePrefix = shopifyRoute.replace(/\/$/, '');

  // --- LAYER 1: Click delegation (capture phase) ---
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a.kuRECSItemClick, a.kcResultItemImageLink, .klevu-recs a[href]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (href && href.indexOf(routePrefix + '/') === -1) {
      e.preventDefault();
      try {
        var urlObj = new URL(href, window.location.origin);
        window.location.href = urlObj.origin + routePrefix + urlObj.pathname + urlObj.search + urlObj.hash;
      } catch (ex) {
        window.location.href = routePrefix + href;
      }
    }
  }, true);

  // --- LAYER 2: MutationObserver on .klevu-recs containers ---
  function rewriteRecsURLs(container) {
    var links = container.querySelectorAll('a.kuRECSItemClick, a.kcResultItemImageLink, a[href]');
    links.forEach(function (link) {
      // Only process links that look like product/collection URLs on cultpens.com
      var href = link.getAttribute('href');
      if (!href) return;
      // Skip links that already have the route prefix
      if (href.indexOf(routePrefix + '/') !== -1) return;
      // Only rewrite links that point to the same domain or are relative
      try {
        var urlObj = new URL(href, window.location.origin);
        if (urlObj.origin === window.location.origin) {
          link.setAttribute('href', urlObj.origin + routePrefix + urlObj.pathname + urlObj.search + urlObj.hash);
        }
      } catch (ex) {}
    });
  }

  var observedContainers = new WeakSet();

  function observeRecsContainers() {
    var containers = document.querySelectorAll('.klevu-recs');
    if (containers.length > 0) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var recsContainer = mutation.target.closest('.klevu-recs');
          if (recsContainer) {
            rewriteRecsURLs(recsContainer);
          }
        });
      });
      containers.forEach(function (container) {
        if (!observedContainers.has(container)) {
          observer.observe(container, { childList: true, subtree: true });
          observedContainers.add(container);
        }
      });
    }
  }

  // Rewrite any already-rendered recs
  rewriteRecsURLs(document);

  // Observe existing .klevu-recs containers
  observeRecsContainers();

  // Also watch body for new .klevu-recs containers being added later
  var bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('klevu-recs')) {
            rewriteRecsURLs(node);
          }
          var innerContainers = node.querySelectorAll ? node.querySelectorAll('.klevu-recs') : [];
          innerContainers.forEach(function (c) {
            rewriteRecsURLs(c);
          });
          if (node.querySelectorAll && node.querySelectorAll('.kuRECSItemClick, .kcResultItemImageLink').length > 0) {
            rewriteRecsURLs(node);
          }
        }
      });
    });
    observeRecsContainers();
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });

  // --- LAYER 3: Polling fallback (10 seconds) ---
  var pollCount = 0;
  var pollInterval = setInterval(function () {
    rewriteRecsURLs(document);
    pollCount++;
    if (pollCount >= 20) clearInterval(pollInterval);
  }, 500);
})();
// RECS URL FIX END

// setting default products on collection page
  var klevu_newObject = klevu.dictionary("limits");
      klevu_newObject.setStorage("local");
      klevu_newObject.mergeFromGlobal();
      klevu_newObject.addElement("productList", 48);
      klevu_newObject.addElement("productListFallback", 48);
      klevu_newObject.addElement("contentList", 48);
      klevu_newObject.mergeToGlobal();


klevu.coreEvent.attach("setRemoteConfigRecsBaseUpdates", {
  name: "klevuRECSCustomizationCurrency",
  fire: function () {
      klevu.recs.base.getScope().chains.search.control.add({
          name: "productCurrencyRECS",
          fire: function (data, scope) {
              var parentScope = scope.recsScope;
              parentScope.searchObject.getScope().currency.setCurrencys({
                  'GBP': {
                    string: "£",
                    format: "%s%s",
                    atEnd: false,
                    precision: 2,
                    thousand: ".",
                    decimal: ".",
                    grouping: 3
                }
              });
              parentScope.searchObject.getScope().currency.mergeToGlobal();
          }
      });
  }
});